import * as braze from '@braze/web-sdk';
import { jwtSubject } from './jwt_helper';
let brazeClient = null;

const client = () => {
  return brazeClient;
};

const resetBraze = () => {
  brazeClient = null;
};

async function initBraze() {
  if (brazeClient) return brazeClient; // Return the existing instance if already initialized

  const { apiKey: brazeApiKey, baseUrl: brazeBaseUrl, devMode } = window.brazeConfig || {};

  if (!brazeApiKey || !brazeBaseUrl) {
    if (devMode) {
      console.warn('Braze API key or base URL missing. Braze SDK will not be initialized.');
    }
    return null;
  }

  try {
    braze.initialize(brazeApiKey, {
      baseUrl: brazeBaseUrl,
      enableLogging: devMode === true,
      allowUserSuppliedJavascript: true,
    });

    // Identify user if available
    const brazeUserId = jwtSubject();

    if (brazeUserId) {
      braze.changeUser(brazeUserId);
    }

    // Open the session
    braze.openSession();

    // allow in app messaging to be shown automatically
    braze.automaticallyShowInAppMessages();

    brazeClient = braze;
    if (devMode) {
      console.log('Braze SDK initialized successfully');
    }

    // set Braze to global window object for access by Growthbook
    window.braze = brazeClient;

    document.dispatchEvent(new Event('brazeLoaded'));

    return brazeClient;
  } catch (e) {
    if (devMode) {
      console.error('Error initializing Braze:', e);
    }
    return null;
  }
}

export {
  client,
  resetBraze,
  initBraze,
};

